import unitConverter from 'convert-units';

export function extractLocation(location) {
  if (Array.isArray(location)) {
    return location[0];
  }

  return location;
}

export function getLocationTimezone(location) {
  const parsedLocation = extractLocation(location);

  if (!parsedLocation) {
    return '';
  }

  const { location_timezone, market } = parsedLocation;

  if (location_timezone) {
    return location_timezone;
  }

  return (market || {}).timezone || '';
}

export function convertDistance(distance, fromUnit = 'm', toUnit = 'mi') {
  return unitConverter(distance)
      .from(fromUnit)
      .to(toUnit).toFixed(2);
}
